import React, { CSSProperties, FC, useRef } from 'react';
import Slider from 'react-slick';
import SliderButton from '@components/common/sliderButton';
import PositionBookmarkListItem from '@components/common/positionBookmarkListItem';
import { PositionBookmarkListItemVO } from '@domain/vo/common/PositionBookmarkListItemVO';

import classnames from 'classnames/bind';
import styles from './positionList.module.scss';
const cx = classnames.bind(styles);

const PrevArrow = (props: { className?: string; style?: CSSProperties; onClick?: () => void }) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'prev'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnPrev')}
      theme="dark"
    />
  );
};

const NextArrow = (props: { className?: string; style?: CSSProperties; onClick?: () => void }) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'next'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnNext')}
      theme="dark"
    />
  );
};

interface SkillPositionListProps {
  positionList: PositionBookmarkListItemVO[];
}

const SkillPositionList: FC<SkillPositionListProps> = ({ positionList }) => {
  const dragging = useRef(false);
  const positionListEl = positionList?.map((item, index) => {
    return (
      <div className={cx('listItemWrap')} key={index}>
        <PositionBookmarkListItem index={index} data={item} theme="dark" dragging={() => dragging.current} />
      </div>
    );
  });

  const settings = {
    infinite: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 300,
    cssEase: 'ease-in-out',
    draggable: true,
    beforeChange: () => (dragging.current = true),
    afterChange: () => (dragging.current = false),
  };

  return (
    <div className={cx('positionListArea')}>
      <Slider {...settings}>{positionListEl}</Slider>
    </div>
  );
};

export default SkillPositionList;
